import React from 'react';
import { Box, Pagination } from '@mantine/core';

export interface TripPaginationProps {
  /** Total number of pages */
  totalPages: number;
  /** Current page index (0-based, matches API) */
  currentPage: number;
  /** Called with 0-based page index when user changes page */
  onPageChange: (page: number) => void;
}

/**
 * Reusable pagination controls for list pages.
 * Uses 0-based page index in props/callbacks; converts to Mantine's 1-based display internally.
 */
const TripPagination: React.FC<TripPaginationProps> = ({
  totalPages,
  currentPage,
  onPageChange,
}) => {
  if (totalPages <= 1) {
    return null;
  }

  const handleChange = (page: number) => {
    onPageChange(page - 1);
  };

  return (
    <Box ta="center" mt="xl">
      <Pagination
        total={totalPages}
        value={currentPage + 1}
        onChange={handleChange}
        size="lg"
        withEdges
      />
    </Box>
  );
};

export default TripPagination;
